<body class="main-shell-body">
  <app-nav-menu></app-nav-menu>
  <div class="container-fluid main-container" [ngStyle]="{'height': '100%' , 'padding-top': environmentSetting == 'UAT' ? '150px' : '100px'}">
    <router-outlet></router-outlet>
  </div>
</body>
